import {
  FILTER_KEY_DATE_RANGE,
  FILTER_KEY_STATUSES,
  FILTER_KEY_TIME_CATEGORY,
  FILTER_KEY_TYPES,
} from './time-offs-filter-keys';

// The approvals table reuses the same filter keys as the Time-Offs page (they map
// to the same backend filter shape: typeIds, statuses, timeCategory, dateRange).
// Re-exported so approvals files import everything filter-related from one place.
export { FILTER_KEY_DATE_RANGE, FILTER_KEY_STATUSES, FILTER_KEY_TIME_CATEGORY, FILTER_KEY_TYPES };

export const TIME_OFF_APPROVALS_TABLE_FILTER_KEYS = [
  FILTER_KEY_TYPES,
  FILTER_KEY_STATUSES,
  FILTER_KEY_TIME_CATEGORY,
  FILTER_KEY_DATE_RANGE,
];

export const TIME_OFF_APPROVALS_TABLE_FILTERS_STORAGE_KEY = 'time-off-approvals-table-filters';

export const TIME_OFF_APPROVALS_TABLE_ID = 'time-off-approvals-list';
